import {
  RECEIVED_CUSTOMER,
  CHECKING_CUSTOMER,
  SEND_SUCCESS,
} from "../actions/remediation";

const remediationInitialState = {
  dataStatus: {},
  connectionStatus: null,
  address: null,
  sentSuccess: false,
};

const remediationReducer = (state = remediationInitialState, action) => {
  switch (action.type) {
    case "LOGOUT_STORE":
    case "RESET_STORE":
      return {
        ...remediationInitialState,
      };
    case CHECKING_CUSTOMER:
      return {
        ...state,
        address: null,
      };
    case RECEIVED_CUSTOMER:
      return {
        ...state,
        address: action.payload,
      };
    case SEND_SUCCESS:
      return {
        ...state,
        sentSuccess: true,
      };
    default:
      return state;
  }
};

export default remediationReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/remediation.js